export class HeaderElement {
  constructor(settings) {
    if (settings && typeof settings === "object") {
      /**
       * type: String
       * location: String[left, center, right]
       * css: String
       * styles: String
       * value: String
       * action: Function
       * elements: Array
       * iconSettings: Object
       */

      this.type = settings.type ? settings.type : "text";
      this.location = settings.location ? settings.location : "left";
      this.cssClasses = settings.css ? settings.css : "";
      this.value = settings.value ? settings.value : null;
      this.action = settings.action ? settings.action : null;
      this.styles = settings.styles ? settings.styles : {};
      this.elements = [];
      this.iconSettings = settings.iconSettings ? settings.iconSettings : null;

      if (
        settings.elements &&
        Array.isArray(settings.elements) &&
        settings.elements.length > 0
      ) {
        settings.elements.forEach((e) =>
          this.elements.push(new HeaderElement(e))
        );
      }
    }
  }

  getType() {
    return this.type ? this.type : "text";
  }

  getPostion() {
    return this.location ? this.location : "left";
  }

  getContent() {
    const type = this.getType();
    let content = null;

    switch (this.type) {
      case "text":
      case "icon":
        content = this.value;
        break;
      case "dropdown":
        break;
    }

    return content;
  }
}
